import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';

import Api from '../../Services/Api';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      passwordConfirmation: '',
      resetToken: props.match.params.resetToken
    };

    this.postForm = this.postForm.bind(this);
    this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this);
  }

  postForm() {
    if (this.state.password === this.state.passwordConfirmation) {
      this.request = Api.get('v1/users/password', {
        method: 'PUT',
        body: JSON.stringify({
          password: this.state.password,
          passwordConfirmation: this.state.passwordConfirmation,
          resetToken: this.state.resetToken
        }),
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }
      }, false, false).then((response) => {
        this.refs.notificationSystem.addNotification({
          message: response.message,
          level: 'success',
          position: 'tc'
        });
        setTimeout(() => {
          this.props.history.push('/login');
        }, 2500);
      }).catch((error) => {
        console.error(error);
      });
    }
  }

  handleSubmitOnEnter(event) {
    if (event.keyCode === 13) {
      this.postForm();
    }
  }

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <div className="authentication-form">
          <h1 className="logo">Huvercraft</h1>
          <div className="form-content">
            <h4>Change Password</h4>
            <input id="password" type="password" placeholder="Password" className="first-child" value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              onKeyDown={this.handleSubmitOnEnter}
              autoFocus
            />

            <input id="password-confirm" type="password" placeholder="Confirm Password" className="last-child" value={this.state.passwordConfirmation}
              onChange={e => this.setState({ passwordConfirmation: e.target.value })}
              onKeyDown={this.handleSubmitOnEnter}
            />

            <button type="button" onClick={this.postForm} className="btn btn-medium btn-primary">Change Password</button>
          </div>
        </div>
        <div className="spinner hide">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
      </div>
    );
  }
}

export default ChangePassword




// WEBPACK FOOTER //
// ./src/Containers/User/ChangePassword.js